import React from "react";
import { motion } from "framer-motion";

const NotFound = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h1 className="text-5xl font-bold text-center mt-20 bg-green-400 ">404</h1>
      <h2 className="text-3xl font-bold text-center mb-4 bg-green-400">
        Sayfa Bulunamadı
      </h2>
      <p className="text-lg text-center mb-8 bg-green-400">
        Aradığınız sayfa maalesef mevcut değil.
      </p>
      <img
        src="https://http.cat/404"
        alt="404 Cat"
        className="mx-auto block"
        style={{ maxWidth: "80%" }}
      />
    </motion.div>
  );
};

export default NotFound;